document.documentElement.classList.remove('no-js');

function updateExpectedDelivery() {
  const today = new Date();
  const deliveryStart = new Date(today);
  const deliveryEnd = new Date(today);
  deliveryStart.setHours(12, 0, 0, 0);
  deliveryEnd.setHours(12, 0, 0, 0);
  deliveryStart.setDate(deliveryStart.getDate() + 4);
  deliveryEnd.setDate(deliveryEnd.getDate() + 7);
  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    month: 'short', day: 'numeric'
  });
  document.querySelectorAll('[data-expected-delivery]').forEach((element) => {
    element.textContent = `${element.dataset.deliveryPrefix} ${dateFormatter.format(deliveryStart)} to ${dateFormatter.format(deliveryEnd)}`;
  });
}

updateExpectedDelivery();
document.addEventListener('shopify:section:load', updateExpectedDelivery);

if (new URLSearchParams(window.location.search).get('navyoro_buy_now') === '1') {
  window.history.replaceState(window.history.state, '', window.location.pathname + window.location.hash);
  window.addEventListener('load', () => {
    document.querySelector('[data-cart-checkout]')?.click();
  });
}

const themeToggle = document.querySelector('[data-theme-toggle]');

function syncThemeToggle() {
  const isDark = document.documentElement.dataset.theme === 'dark';
  themeToggle?.setAttribute('aria-pressed', String(isDark));
  themeToggle?.setAttribute('aria-label', isDark ? 'Use light mode' : 'Enable dark mode');
}

syncThemeToggle();

themeToggle?.addEventListener('click', () => {
  const isDark = document.documentElement.dataset.theme === 'dark';

  if (isDark) {
    delete document.documentElement.dataset.theme;
    try {
      window.localStorage.setItem('nayvoro-theme', 'light');
    } catch (error) {}
  } else {
    document.documentElement.dataset.theme = 'dark';
    try {
      window.localStorage.setItem('nayvoro-theme', 'dark');
    } catch (error) {}
  }

  syncThemeToggle();
});

const menu = document.querySelector('[data-mobile-menu]');
const openButton = document.querySelector('[data-menu-open]');
const closeButton = document.querySelector('[data-menu-close]');

function setMenu(open) {
  if (!menu || !openButton) return;
  menu.classList.toggle('is-open', open);
  menu.setAttribute('aria-hidden', String(!open));
  openButton.setAttribute('aria-expanded', String(open));
  document.body.classList.toggle('menu-open', open);
  if (open) closeButton?.focus();
}

openButton?.addEventListener('click', () => setMenu(true));
closeButton?.addEventListener('click', () => setMenu(false));
menu?.addEventListener('click', (event) => {
  if (event.target === menu) setMenu(false);
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') setMenu(false);
});

document.querySelectorAll('[data-variant-select]').forEach((select) => {
  select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const price = select.closest('[data-product-form]')?.querySelector('[data-product-price]');
    const button = select.closest('[data-product-form]')?.querySelector('[data-add-button]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (button) {
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.availableText : button.dataset.soldText;
    }
  });
});
